import React, { useState } from "react";
import axios from "axios";
import { CheckCircle2, Clock, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminFirmStatus = ({ firm, token, onChange }) => {
  const [busy, setBusy] = useState(false);
  if (!firm?.status) return null;
  const pending = firm.status === "pending";

  const toggle = async () => {
    setBusy(true);
    try {
      await axios.patch(`${API}/admin/firms/${firm.id}/status`, { status: pending ? "approved" : "pending" }, { headers: { Authorization: `Bearer ${token}` } });
      await onChange();
    } finally { setBusy(false); }
  };

  return (
    <div className="flex items-center gap-2" data-testid="admin-firm-status">
      <span className={`inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-medium ${pending ? "bg-[#FFF3D6] text-[#8a6a1f]" : "bg-emerald-50 text-emerald-700"}`} data-testid="admin-firm-status-badge">
        {pending ? <Clock className="w-3.5 h-3.5" /> : <CheckCircle2 className="w-3.5 h-3.5" />}
        {pending ? "Onay Bekliyor" : "Yayında"}
      </span>
      <button onClick={toggle} disabled={busy} data-testid="admin-firm-status-toggle"
        className={`inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full text-sm font-medium transition-colors disabled:opacity-60 ${pending ? "bg-[#3F8F5A] text-white hover:bg-[#357a4c]" : "border border-white/60 text-white hover:bg-white/10"}`}>
        {busy && <Loader2 className="w-4 h-4 animate-spin" />}
        {pending ? "Onayla ve Yayınla" : "Beklemeye Al"}
      </button>
    </div>
  );
};
